/**
 * Route /_auth/notifications — W4.6 / F-H.2
 *
 * Notification-Log mit Filter (inkl. Bans/Watched) + Mark-all-read.
 * Echte API-Anbindung via useNotifications (GET /api/v2/notifications,
 * POST /api/v2/notifications/mark_all_read) — beide existieren im
 * Rails-Backend (app/controllers/api/v2/notifications_controller.rb), fehlen
 * aber weiterhin im openapi.yaml-Contract (Stand api-types 0.3.0), daher der
 * Cast auf einen ungetypten GET/POST in useNotifications.ts. Graceful
 * Degradation auf 404, falls der Contract-Nachtrag ausbleibt.
 */
import { createFileRoute } from '@tanstack/react-router'
import { NotificationsPage } from '../features/notifications/NotificationsPage'

export const Route = createFileRoute('/_auth/notifications')({
  component: NotificationsPage,
})
